export default __webpack_public_path__ + "static/media/chevron-down-dark.69ee32a7.svg";